package com.taocent.simple.compose.component.blockrichtext

/**
 * 跨 block 进入表格单元格的请求载荷。
 *
 * 由 [BlockState.pendingEnterTableCell] 持有,在 TextBlock ↑↓ 进入相邻表格时写入,
 * 由 TableRenderer 在下一帧消费并清空。
 *
 * @param tableId 目标表格 id
 * @param rowId 目标行 id(通常是首行或末行)
 * @param cellId 目标单元格 id
 * @param caretAtEnd 进入后光标位置:true=cell 末尾,false=cell 开头
 */
internal data class PendingEnterTableCell(
    val tableId: String,
    val rowId: String,
    val cellId: String,
    val caretAtEnd: Boolean
)
